<div class="form-row mr-bottom-16 wrappable" [formGroup]="privatePersonFormGroup">
  <div class="form-col form-col-2">
    <np-phone-input
      data-test-id="ContactPhone"
      [isValid]="privatePersonFormGroup.controls.phone.valid"
      formControlName="phone"
      placeholder="Телефон"
      autocomplete="off"
      [formControlParent]="privatePersonFormGroup.get('phone')"
      (change)="onChangePhone($event)">
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(phoneControl, phoneErrors) }}
      </mat-error>
    </np-phone-input>
  </div>
  <div class="form-col form-col-2">
    <mat-form-field class="mat-block">
      <input data-test-id="ContactLastname"
             #lastNameInput
             type="text"
             matInput
             formControlName="lastName"
             placeholder="Прізвище"
             class="text-capitalize"
             [LetterInput]="true"
             [allowDash]="true"
             [onlyCyrillic]="true"
             [matAutocomplete]="auto"
             [errorStateMatcher]="matcher"
             capitalizeWithDash
             autoScrollTarget>
      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="setContactFromCatalog($event)">
        <mat-option *ngFor="let option of catalogOptions"
                    [value]="option">
          <div class="option-field option-field_sm">
            <div class="option-field__hint">{{option.Description}}</div>
            <div class="option-field__text">{{option.LastName}} {{option.FirstName}} {{option.MiddleName}}</div>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(lastNameControl, nameErrors) }}
      </mat-error>
    </mat-form-field>

  </div>
  <div class="form-col form-col-2">
    <mat-form-field class="mat-block">
      <input data-test-id="ContactFirstname"
             matInput
             formControlName="firstName"
             placeholder="Ім’я"
             class="text-capitalize"
             [LetterInput]="true"
             [allowDash]="true"
             [onlyCyrillic]="true"
             [errorStateMatcher]="matcher"
             capitalizeWithDash
             autoScrollTarget>
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(firstNameControl, nameErrors) }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="form-col form-col-2 box-with-controls" [ngClass]="{'last-col' : IsEnabledCancel}">
    <mat-form-field class="mat-block">
      <input data-test-id="ContactMiddlename"
             matInput
             formControlName="middleName"
             placeholder="По батькові"
             class="text-capitalize"
             [LetterInput]="true"
             [allowDash]="true"
             [onlyCyrillic]="true"
             [errorStateMatcher]="matcher"
             capitalizeWithDash
             autoScrollTarget>
      <mat-error>
        <i class="material-icons mat-select-error__icon">error_outline</i>
        {{ getError(middleNameControl, nameErrors) }}
      </mat-error>
    </mat-form-field>
    <div class="control-icons" *ngIf="IsEnabledCancel">
      <div class="control-icons__item">
        <button mat-icon-button (click)="cancel()">
          <mat-icon class="material-icons_grey">
            cancel
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
